import { fromJS, Map } from 'immutable';

export function request(state, action) {
    let collections = state.get('collections');

    collections = collections.set(action.id, fromJS({
        state: 'IN_PROGRESS',
        items: []
    }));

    return state.set('collections', collections);
}

export function error(state, action) {
    let collections = state.get('collections');

    collections = collections.set(action.id, fromJS({
        state: 'ERROR',
        errors: fromJS(action.errors)
    }));

    return state.set('collections', collections);
}

export function finish(state, { id, transactions }) {
    let collections = state.get('collections');

    collections = collections.set(id, fromJS({
        state: 'FINISHED',
        items: fromJS(transactions.map(bet => bet.id))
    }));

    let items = state.get('items');
    for (let transaction of transactions) {
        items = items.set(transaction.id, fromJS(transaction));
    }

    return state
        .set('items', items)
        .set('collections', collections);
}

export function clear(state, { id }) {
    return state.set(
        'collections',
        state.get('collections').remove(id)
    );
}

